import FileCopyIcon from "@material-ui/icons/FileCopy";
import GuardarPlantillaPartidaDialog from "../../../components/dialogs/GuardarPlantillaPartidaDialog";
import { Button, CircularProgress, MenuItem, TextField, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { deletePartida, getPartidas, getPartidaById } from "../../../../api/partida";
import { getPartidaCategories } from "../../../../api/partidaCategory";
import { getCustomers } from "../../../../api/customer";
import { ROLES } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, { buttonsStyle } from "../../../components/tables/table";
import CreatePartidaSubcategoryDialog from "../../../components/dialogs/CreatePartidaSubcategoryDialog";
import CreatePartidaDialog from "../../../components/dialogs/CreatePartidaDialog";
import LoadingDialog from "../../../components/dialogs/LoadingDialog";
import { getPartidaCategoryLabel } from "../../../../utils/categoryTree";
import PartidaCategoryTree from "../../../components/partidas/PartidaCategoryTree";
import "./PartidasPage.scss";




function getData(partidas, categories, filters) {
	let data = [];
	const getCategoryKey = (id) => (id ? String(id).toLowerCase() : "");
	const categoryById = new Map(
		(categories || []).map((category) => [getCategoryKey(category.id), category])
	);
	const rootCategoryId = getCategoryKey(filters?.categoria?.id);
	const subcategoryId = getCategoryKey(filters?.subcategoriaId);
	for (let i = 0; i < partidas.length; ++i) {
		const elem = {};
		const partida = partidas[i];

		elem.referencia = partida?.referencia;
		elem.descripcion = partida?.descripcion;
		const partidaCategories = (partida?.categorias?.length
			? partida.categorias
			: [partida?.categoria].filter(Boolean))
			.map((category) => categoryById.get(getCategoryKey(category?.id)) || category);
		const visibleCategories = rootCategoryId
			? partidaCategories.filter((category) => {
				const categoryId = getCategoryKey(category?.id);
				if (subcategoryId) return categoryId === subcategoryId;
				return (
					categoryId === rootCategoryId ||
					getCategoryKey(category?.categoria_padre_id) === rootCategoryId
				);
			})
			: partidaCategories;
		const directRootCategory = visibleCategories.find(
			(category) => getCategoryKey(category?.id) === rootCategoryId
		);
		const displayedCategories = directRootCategory && !subcategoryId
			? [directRootCategory]
			: visibleCategories;
		elem.categoria = displayedCategories
			.map((category) =>
				rootCategoryId ? category?.descripcion || "" : getPartidaCategoryLabel(category, categories)
			)
			.join(", ");
		elem.cliente = partida?.cliente_nombre || "General";
		elem.id = partida?.id;

		data = data.concat(elem);
	}
	return data;
}

const initialFilters = {
	categoria: null,
	subcategoriaId: "",
	clienteId: "",
};

const GENERAL_CUSTOMER_FILTER = "__general__";

function filterPartidas(partidas, categories, filters) {
	const rootCategoryId = filters.categoria?.id;
	const categoryIds = new Set();
	if (filters.subcategoriaId) {
		categoryIds.add(String(filters.subcategoriaId).toLowerCase());
	} else if (rootCategoryId) {
		categoryIds.add(String(rootCategoryId).toLowerCase());
		categories
			.filter((category) => String(category.categoria_padre_id || "").toLowerCase() === String(rootCategoryId).toLowerCase())
			.forEach((category) => categoryIds.add(String(category.id).toLowerCase()));
	}

	return partidas.filter((partida) => {
		if (categoryIds.size > 0 && !(partida?.categorias?.length
			? partida.categorias
			: [partida?.categoria]
		).some((category) => categoryIds.has(String(category?.id || "").toLowerCase()))) {
			return false;
		}
		if (filters.clienteId === GENERAL_CUSTOMER_FILTER) return !partida?.cliente_id;
		if (filters.clienteId) return String(partida?.cliente_id || "") === String(filters.clienteId);
		return true;
	});
}

export default function PartidasPage() {
	const history = useHistory();
	const location = useLocation();
	const categoryPanelRef = useRef(null);
	const [categoryPanelMaxHeight, setCategoryPanelMaxHeight] = useState(null);
	const [data, setData] = useState([]);
	const [selectedPartida, setSelectedPartida] = useState(null);

	const [openGuardarPlantillaPartidaDialog, setOpenGuardarPlantillaPartidaDialog] = useState(false);
	const [guardarPlantillaPartida, setGuardarPlantillaPartida] = useState(null);

	const [partidaCategories, setPartidaCategories] = useState([]);
	const [customers, setCustomers] = useState([]);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [isLoadingPartidas, setIsLoadingPartidas] = useState(true);
	const [isLoadingPartidaDetail, setIsLoadingPartidaDetail] = useState(false);

	const [refresh, setRefresh] = useState(false);

	const [filterOptions, setFilterOptions] = useState(initialFilters);
	const [expandedCategoryIds, setExpandedCategoryIds] = useState(new Set());
	const [openCreateSubcategoryDialog, setOpenCreateSubcategoryDialog] = useState(false);
	const [openCreatePartidaDialog, setOpenCreatePartidaDialog] = useState(false);
	const [partidaToEdit, setPartidaToEdit] = useState(null);

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);
	const filteredData = useMemo(
		() => filterPartidas(data, partidaCategories, filterOptions),
		[data, partidaCategories, filterOptions]
	);
	const rootCategories = useMemo(
		() => partidaCategories
			.filter((category) => !category.categoria_padre_id)
			.sort((a, b) => (a.descripcion || "").localeCompare(b.descripcion || "", "es", { sensitivity: "base" })),
		[partidaCategories]
	);

	useLayoutEffect(() => {
		let frame;
		const measureVisibleHeight = () => {
			if (!categoryPanelRef.current) return;
			const panelTop = categoryPanelRef.current.getBoundingClientRect().top;
			const availableHeight = Math.max(120, Math.floor(window.innerHeight - panelTop - 16));
			setCategoryPanelMaxHeight(
				window.matchMedia("(max-width: 900px)").matches
					? Math.min(340, availableHeight)
					: availableHeight
			);
		};
		const scheduleMeasure = () => {
			window.cancelAnimationFrame(frame);
			frame = window.requestAnimationFrame(measureVisibleHeight);
		};
		measureVisibleHeight();
		window.addEventListener("resize", scheduleMeasure);
		window.addEventListener("scroll", scheduleMeasure, true);
		return () => {
			window.cancelAnimationFrame(frame);
			window.removeEventListener("resize", scheduleMeasure);
			window.removeEventListener("scroll", scheduleMeasure, true);
		};
	}, []);

	async function openPartidaEditor(partidaId) {
		setIsLoadingPartidaDetail(true);
		try {
			const response = await getPartidaById(partidaId, loggedUser?.accessToken);
			if (response.status === 200) {
				setPartidaToEdit(response.data);
				setOpenCreatePartidaDialog(true);
			}
		} catch (error) {
			alertError({ error, customMessage: "No se ha podido cargar la partida para editarla." });
		} finally {
			setIsLoadingPartidaDetail(false);
		}
	}

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
								openPartidaEditor(cell);
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
					<>
						<Tooltip title="Copiar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={(e) => {
									e.stopPropagation();

									getPartidaById(elem.id, loggedUser?.accessToken)
										.then((res) => {
											if (res.status === 200) {
												console.log(res);
												setGuardarPlantillaPartida(res.data);   // aquí ya viene productos/descompuesto
												setOpenGuardarPlantillaPartidaDialog(true);
											}
										})
										.catch((error) => {
											alertError({
												error,
												customMessage: "No se ha podido cargar el detalle de la partida para copiarla.",
											});
										});
								}}
							>
								<FileCopyIcon />
							</Button>
						</Tooltip>
						<Tooltip title="Eliminar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									setSelectedPartida(elem);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{
			dataField: "referencia",
			text: "Referencia",
			sort: true,
			headerStyle: { width: "20%" },
			style: { width: "20%" },
		},
		{
			dataField: "descripcion",
			text: "Descripción",
			sort: true,
			headerStyle: { width: "43%" },
			style: { width: "43%" },
		},
		{
			dataField: "categoria",
			text: "Categoría",
			sort: true,
			headerAlign: "center",
			align: "center",
			headerStyle: { width: "18%" },
			style: { width: "18%" },
		},
		{
			dataField: "cliente",
			text: "Cliente",
			sort: true,
			headerAlign: "center",
			align: "center",
			headerStyle: { width: "10%" },
			style: { width: "10%" },
		},
		{
			dataField: "id",
			text: "",
			formatter: buttonFormatter,
			headerAlign: "right",
			align: "right",
			headerStyle: { width: "9%" },
			style: { width: "9%", whiteSpace: "nowrap" },
		},
	];

	useEffect(() => {
		if (!loggedUser?.accessToken) return;
		setIsLoadingPartidas(true);
		getPartidaCategories(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setPartidaCategories(res.data);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido obtener las categorías.",
				});
			});
		getCustomers(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setCustomers((res.data || []).filter((customer) => customer?.activo));
				}
			})
			.catch((error) => {
				alertError({
					error,
					customMessage: "No se han podido obtener los clientes para el filtro.",
				});
			});
		getPartidas(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido obtener las partidas.",
				});
			})
			.finally(() => setIsLoadingPartidas(false));
	}, [refresh, loggedUser?.accessToken]);

	const updateCategoryFilters = (nextFilters) => {
		setFilterOptions(nextFilters);
		const searchParams = new URLSearchParams(location.search);
		if (searchParams.has("page") && searchParams.get("page") !== "1") {
			searchParams.set("page", "1");
			history.replace({ pathname: location.pathname, search: searchParams.toString() });
		}
	};

	const handleClearFilters = () => {
		updateCategoryFilters(initialFilters);
	};

	const renderFiltersContent = () => {
		return (
			<>
				<div className="d-sm-flex w-100">
					<TextField
						select
						className="partidas-client-filter"
						label="Cliente"
						value={filterOptions.clienteId}
						onChange={(event) =>
							updateCategoryFilters({
								...filterOptions,
								clienteId: event.target.value,
							})
						}
						InputLabelProps={{ shrink: true }}
						margin="normal"
						variant="outlined"
					>
						<MenuItem value="">&lt;Todos&gt;</MenuItem>
						<MenuItem value={GENERAL_CUSTOMER_FILTER}>General</MenuItem>
						{customers.map((customer) => (
							<MenuItem key={customer.id} value={customer.id}>
								{customer.nombre}
							</MenuItem>
						))}
					</TextField>
				</div>
			</>
		);
	};

	const toggleCategory = (categoryId) => {
		setExpandedCategoryIds((current) => {
			const next = new Set(current);
			if (next.has(categoryId)) next.delete(categoryId);
			else next.add(categoryId);
			return next;
		});
	};

	return (
		<>
			<Card>
				<CardHeader headerClassName="px-0">
					<CardHeader
						title="Partidas"
						sticky={false}
						headerClassName="d-flex justify-content-between w-100 py-3"
					>
						<CardHeaderToolbar>
							<button
								type="button"
								className="btn btn-primary"
								onClick={() => {
									setPartidaToEdit(null);
									setOpenCreatePartidaDialog(true);
								}}
							>
								Nueva partida
							</button>
						</CardHeaderToolbar>
					</CardHeader>
				</CardHeader>
				<CardBody>
					<div className="partidas-layout">
						<PartidaCategoryTree
							panelRef={categoryPanelRef}
							style={categoryPanelMaxHeight == null ? undefined : { maxHeight: categoryPanelMaxHeight }}
							rootCategories={rootCategories}
							categories={partidaCategories}
							selectedRoot={filterOptions.categoria}
							selectedSubcategoryId={filterOptions.subcategoriaId}
							expandedCategoryIds={expandedCategoryIds}
							showAllCategories
							onSelectAll={() => updateCategoryFilters({ ...filterOptions, categoria: null, subcategoriaId: "" })}
							onSelectRoot={(category) => {
								updateCategoryFilters({ ...filterOptions, categoria: category, subcategoriaId: "" });
								setExpandedCategoryIds((current) => new Set(current).add(category.id));
							}}
							onSelectSubcategory={(category, child) => updateCategoryFilters({ ...filterOptions, categoria: category, subcategoriaId: child.id })}
							onToggleCategory={toggleCategory}
							onCreateSubcategory={() => setOpenCreateSubcategoryDialog(true)}
						/>
						<div className="partidas-results">
							<FiltersCard
								collapsable={false}
								filtersContent={renderFiltersContent}
								handleClearFilters={handleClearFilters}
							/>
					{isLoadingPartidas && !data.length ? (
						<div className="d-flex flex-column align-items-center justify-content-center py-10">
							<CircularProgress style={{ color: "#2705c0" }} />
							<span className="mt-3 text-muted">Cargando partidas...</span>
						</div>
					) : (
						<div className="partidas-table-container">
							{isLoadingPartidas && (
								<div className="partidas-loading-overlay">
									<CircularProgress style={{ color: "#2705c0" }} />
									<span className="mt-3 text-muted">Actualizando partidas...</span>
								</div>
							)}
							<Table
								data={getData(filteredData, partidaCategories, filterOptions)}
								columns={columns}
								rowEvents={{
									onClick: (e, row) => openPartidaEditor(row.id),
								}}
							/>
						</div>
					)}
						</div>
					</div>
					<ConfirmDialog
						title={
							"¿Estás seguro de que quieres eliminar esta partida?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deletePartida(
								selectedPartida?.id,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "¡Eliminada!",
											customMessage:
												"Partida eliminado con éxito.",
										});
										setRefresh((current) => !current);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"No se ha podido eliminar la partida.",
									});
								});
						}}
					/>
					{openGuardarPlantillaPartidaDialog && guardarPlantillaPartida && (
						<GuardarPlantillaPartidaDialog
							title="Copiar plantilla de partida"
							open={openGuardarPlantillaPartidaDialog}
							setOpen={setOpenGuardarPlantillaPartidaDialog}
							data={guardarPlantillaPartida}
							onSave={() => setRefresh((current) => !current)}
						/>
					)}
					<CreatePartidaSubcategoryDialog
						open={openCreateSubcategoryDialog}
						setOpen={setOpenCreateSubcategoryDialog}
						parentCategory={filterOptions.categoria}
						onCreated={(subcategory) => {
							setPartidaCategories((current) => [...current, subcategory]);
							setExpandedCategoryIds((current) => new Set(current).add(filterOptions.categoria.id));
							const nextFilters = {
								...filterOptions,
								subcategoriaId: subcategory.id,
							};
							updateCategoryFilters(nextFilters);
						}}
					/>
					<CreatePartidaDialog
						title={partidaToEdit ? "Editar partida" : "Nueva partida"}
						open={openCreatePartidaDialog}
						setOpen={(nextOpen) => {
							setOpenCreatePartidaDialog(nextOpen);
							if (!nextOpen) setPartidaToEdit(null);
						}}
						partidaToEdit={partidaToEdit}
						defaultRootCategoryId={filterOptions.categoria?.id || null}
						defaultSubcategoryId={filterOptions.subcategoriaId || null}
						onSave={() => setRefresh((current) => !current)}
					/>
					<LoadingDialog open={isLoadingPartidaDetail} title="Cargando partida..." />
				</CardBody>
			</Card>
		</>
	);
}
